import React from 'react';
import alertTypes from '../types.js';
import InfoDialog from './components/InfoDialog.jsx';
import ConfirmDialog from './components/ConfirmDialog.jsx';

export const Dialog = ({ open, onSubmit, onClose, type, config }) => {
    switch (type) {
        case alertTypes.INFO:
            return (
                <InfoDialog
                    open={open}
                    onSubmit={onSubmit}
                    onClose={onClose}
                    config={config}
                />
            );
        case alertTypes.CONFIRM:
            return (
                <ConfirmDialog
                    open={open}
                    onSubmit={onSubmit}
                    onClose={onClose}
                    config={config}
                />
            );
        case alertTypes.CUSTOM:
            const CustomBody = config.body;
            const props = config.props ?? {};
            return (
                <CustomBody open={open} onSubmit={onSubmit} onClose={onClose} {...props} />
            );
        default:
            return null;
    }
};
